import { FileQuestion } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';

import { StatusPage } from './status-page';

export function NotFoundPage() {
  return (
    <StatusPage
      icon={FileQuestion}
      code="404"
      title="Page not found"
      description="The page you are looking for does not exist, or it may have been moved. Check the address, or head back to the start."
      actions={
        <Button asChild size="sm">
          <Link to="/">Back to home</Link>
        </Button>
      }
    />
  );
}
